module.exports = __webpack_public_path__ + "img/x-icon.95119caf.svg";